import { createAction } from 'redux-actions';

export default {
  restoreState: createAction('mapFile/RESTORE_STATE'),
  clearMapFiles: createAction('mapFile/CLEAN_MAP_FILES'),
  addNode: createAction('mapFile/ADD_NODE'),
  updateNode: createAction('mapFile/UPDATE_NODE'),
  deleteNode: createAction('mapFile/DELETE_NODE'),
  updateTree: createAction('mapFile/UPDATE_TREE'),
  addFiles: createAction('mapFile/ADD_FILES'),
};
